'use strict';

import DeviceList from './devices.list.ctrl';
import NewDevice from './devices.new.ctrl';
import EditDevice from './edit/editDevice';
import Lintalert from './config/lintalert/properties.ctrl';

export default angular
  .module('main.devices', [
    DeviceList,
    NewDevice,
    EditDevice,
    Lintalert
  ])
  .name;
